<template>
  <div class="timeout-modal">
    <h2>Notice</h2>
    <p>
      Under 2 minutes left until inactivity-logout
    </p>

    <ol>
      <li>
        <button
          class="g-btn g-btn--rounded g-btn--blue"
          type="button"
          name="button"
          @click="ExtendClick"
        >
          Extend
        </button>
      </li>
      <li>
        <button
          class="g-btn g-btn--rounded"
          type="button"
          name="button"
          @click="LogoutClick"
        >
          Log out
        </button>
      </li>
    </ol>
  </div>
</template>

<script>
import {SocketHandler} from '@/assets/javascript/mixins/Mixins'

export default {
  name: 'Timeoutmodal',
  components:
  {
  },
  mixins: [SocketHandler],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
    }
  },
  methods: {
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    LogoutClick() {
      this.$router.push('/')
      this.$emit('SetPageMessage', {
        target: 'ShowModal'
      })
    },
    ExtendClick() {
      this.SocketMessageSend({category: 'server', command: 'extendtime'})
      this.$emit('SetPageMessage', {
        target: 'CloseModal',
        component: 'TimeoutModal'
      })
    }
  }
}
</script>

<style lang="scss">
  .timeout-modal {
    max-width:  325px;
    width: 100%;
    background: $color-white;
    text-align: center;
    border-radius: $application-base-border-radius;
    padding: 20px;

    p {
      margin: 20px;
    }

    ol {
      margin-top: 20px;
      li {
        display: inline-block;
      }
    }
  }
</style>
